import { Component, Input, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';


import { ViBrandIdentity } from '../../models/vi-brand-identity.model';
import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';
import { chartColors } from '@Common/Charts/enums/chart-colors.enum';

@Component({
    selector: 'agpr-vi-brand-identity-readonly-card',
    templateUrl: './vi-brand-identity-readonly-card.component.html',
    styleUrls: ['./vi-brand-identity-readonly-card.component.scss'],
    animations: [
        trigger('cardState', [
            state('collapsed', style({
                height: '0'
            })),
            state('expanded', style({
                height: '*'
            })),
            transition('collapsed <=> expanded', animate('220ms ease-in'))
        ])
    ],
    standalone: false
})
export class ViBrandIdentityReadonlyCardComponent implements OnInit {

    @Input() id: string = 'brandIdentityReadonlyCard';
    @Input() brand: ViBrandIdentity;
    @Input() canToggle: boolean = true;

    cardState: boolean = true;
    logoPlaceholder: string;
    logoPlaceholderColor: string;

    readonly KNUTH_MULTI_HASH: number = 2654435761;
    readonly buttonType = ButtonTypesEnum;
    readonly colorOptions: chartColors[] = [
        chartColors.agprBlue,
        chartColors.agprPurple,
        chartColors.agprLightBlue,
        chartColors.agprOrange,
        chartColors.agprYellow,
        chartColors.agprLightGreen,
        chartColors.agprGreen,
        chartColors.agprTeal,
        chartColors.agprAqua,
        chartColors.agprCoralPink,
        chartColors.agprCrimson,
        chartColors.agprLavender
    ];

    constructor() {}

    ngOnInit() {
        this.logoPlaceholder = this.getPlaceholderText(this.brand.name);
        this.logoPlaceholderColor = this.colorForSeed(this.brand.brandId ?? 0);
    }

    private getPlaceholderText(name: string): string {
        const trimmed = name?.trim() ?? '';
        if (!trimmed) {
            return '';
        }
        const words = trimmed.split(' ');
        if (words.length === 1) {
            return trimmed.slice(0, Math.min(trimmed.length, 2)).toLocaleUpperCase();
        }
        return words[0][0].toLocaleUpperCase() + words[words.length - 1][0].toLocaleUpperCase();
    }

    /**
     * Deterministic colour per brand; the odd constant scatters sequential IDs across the palette.
     */
    private colorForSeed(seed: number): string {
        const scattered = Math.abs(seed * this.KNUTH_MULTI_HASH) % this.colorOptions.length;
        return this.colorOptions[scattered];
    }
}
